import { Rule } from "pages/Rules/common/types";
import { useTranslation } from "react-i18next";
import EmailFlowDetails from "./EmailFlowDetails";
import MailboxDetails from "./MailboxDetails";
import { UnstyledList } from "../styled";
import FilterPolicyDetails from "./FilterPolicyDetails";
import { typePath } from "pages/Rules/Form/context/ruleSelectors";

export default function TargetDetails({ rule }: { rule: Rule }) {
  const { t } = useTranslation("rules");
  if (!rule.targetType) return null;

  const actionData = typePath(rule.actionType, rule);

  if (
    rule.targetType === "ARCHIVING_ADDRESS" &&
    "archivingAddress" in actionData
  ) {
    return (
      <UnstyledList>
        <li
          style={{
            overflowWrap: "anywhere",
          }}
        >
          {t("sentTo")}
          {actionData?.archivingAddress?.emailAddress}
        </li>
        {rule.filterPolicyId && (
          <li>
            <FilterPolicyDetails rule={rule} />
          </li>
        )}
      </UnstyledList>
    );
  }

  if ("mailbox" in actionData && actionData.mailbox) {
    return (
      <UnstyledList>
        <MailboxDetails mailbox={actionData.mailbox} />
        {rule.filterPolicyId && (
          <li>
            <FilterPolicyDetails rule={rule} />
          </li>
        )}
      </UnstyledList>
    );
  }

  if ("emailFlow" in actionData && actionData.emailFlow) {
    return (
      <>
        <EmailFlowDetails emailFlow={actionData.emailFlow} />
        {rule.filterPolicyId && <FilterPolicyDetails rule={rule} />}
      </>
    );
  }

  return null;
}
